module.exports = __webpack_public_path__ + "e2c9ca5b33878a4a81e0ee62be329928.jpg";